// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clockpicker-display-column[data-v-200a2922] {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n.clockpicker-span-hours[data-v-200a2922]:focus,\n.clockpicker-span-minutes[data-v-200a2922]:focus {\n  color: white !important;\n  outline: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
